<template>
  <b-card class="p-3 px-lg-5 text-left" no-body>
    <div class="form-side">
      <slot name="header"></slot>

      <h4 v-if="title">{{ title }}</h4>
      <div class="mb-5" v-if="title"></div>

      <b-form @submit.prevent="handleSubmit" :novalidate="true">
        
        <slot name="fields"></slot>

        <div class="d-flex justify-content-between flex-row-reverse" v-if="action">
          <transition name="fade" mode="out-in">
            <b-button
              :disabled="submitStatus === 'PENDING'"
              type="submit"
              variant="primary"
              class="btn-shadow"
              :class="{'btn-block' : (btnBlock)}"
            >
              <span v-if="!loading">{{ action }}</span>
              <span class="spinner d-inline-block" v-if="loading">
                <span class="bounce1"></span>
                <span class="bounce2"></span>
                <span class="bounce3"></span>
              </span>
            </b-button>
          </transition>

            <slot name="buttons" v-if="!btnBlock"></slot>
        </div>

        <slot name="buttons" v-if="btnBlock"></slot>

        <transition name="fade" mode="in-out">
          <b-alert show variant="danger" class="mt-3" v-if="errors">
            <ul>
              <span v-for="(key) in errors" :key="String(key)">
                <li v-for="error in key" :key="String(error)">{{ error }}</li>
              </span>
            </ul>
          </b-alert>
        </transition>

        <slot name="footer"></slot>
      </b-form>
    </div>
  </b-card>
</template>

<script>
export default {
  props: ["title", "action", "errors", "loading", "submitStatus", "btnBlock"],

  methods: {
    handleSubmit() {
      this.$emit("handleSubmit");
    },
  },
};
</script>

<style>
</style>
